export function disposeWatchers(state) {
  const watchers = state === null || state === void 0 ? void 0 : state._watchers;
  if (!Array.isArray(watchers)) {
    return;
  }
  let i = watchers.length;
  // eslint-disable-next-line no-plusplus
  while (i--) {
    watchers[i].teardown();
  }
}
//# sourceMappingURL=disposeWatchers.js.map
